import { c as _c } from "react/compiler-runtime";
import { Skeleton_OLD } from '@7f-ui/components/skeleton_old';
export const SkeletonCartItem = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton_OLD.Item className="aspect-square w-20 sm:aspect-auto sm:h-[102px] sm:w-[136px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="col-span-12 mb-5 flex space-x-4">{t0}<div className="flex-1 space-y-2.5"><Skeleton_OLD.Item className="h-4 w-3/4 sm:w-full" /><Skeleton_OLD.Item className="h-4 w-full" /><Skeleton_OLD.Item className="h-4 w-3/4 sm:h-3" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="col-span-12 mb-5 space-y-3 sm:mb-7"><Skeleton_OLD.Item className="h-3 w-4/6" /><Skeleton_OLD.Item className="h-3 w-3/6" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Skeleton_OLD.Item className="aspect-square w-6 rounded-sm" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="col-span-12 mb-4 flex items-start space-x-3">{t3}<div className="flex-1 space-y-2.5"><Skeleton_OLD.Item className="h-3 w-full" /><Skeleton_OLD.Item className="h-3 w-3/4" /></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Skeleton_OLD.Item className="aspect-square w-6 rounded-sm" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Skeleton_OLD className="col-span-12 sm:col-span-7 md:col-span-6 md:col-start-2">{t1}{t2}{t4}<div className="col-span-12 flex items-start space-x-3">{t5}<div className="flex-1 space-y-2.5"><Skeleton_OLD.Item className="h-3 w-full" /><Skeleton_OLD.Item className="h-3 w-3/4" /></div></div></Skeleton_OLD>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};